// extracted by mini-css-extract-plugin
export default {"cls1":"Reader-cls1__cac98ad608507570cb2c","cls2":"Reader-cls2___15abe4336118e4c66ab Reader-cls1__cac98ad608507570cb2c"};